import { render, staticRenderFns } from "./HealthCard.vue?vue&type=template&id=ec045324&scoped=true&"
import script from "./HealthCard.vue?vue&type=script&lang=js&"
export * from "./HealthCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthCard.vue?vue&type=style&index=0&id=ec045324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec045324",
  null
  
)

component.options.__file = "HealthCard.vue"
export default component.exports